import { type JSXElementConstructor, type ReactElement, useEffect } from 'react'

import { usePage } from '@subaio/components/src/Router/usePage'

import { getHeadings } from 'lib/getHeadings'

import { Article } from './Article'
import { Grid } from './Grid'
import { TableOfContents } from './TableOfContents'

type Props = {
	children: ReactElement<any, string | JSXElementConstructor<any>>
	showTableOfContents?: boolean
}

export const Doc = ({ children, showTableOfContents = true, ...rest }: Props) => {
	const headings = getHeadings(children)
	const page = usePage()!

	useEffect(() => {
		if (page.fragment) {
			document.getElementById(page.fragment)?.scrollIntoView()
		}
	}, [page.fragment])

	if (!page) return null

	return (
		<Grid {...rest}>
			<Article>{children}</Article>
			{showTableOfContents && <TableOfContents headings={headings} pageName={page.name} />}
		</Grid>
	)
}
